<div class="container" *ngIf="lang === 'es'">
    <div>
        <p align="center">
            <strong>CONDICIONES DE UTILIZACIÓN</strong></p>
        <p>
            Última actualización: 07/09/2020
        </p>    
        <br>    
    </div>
    <ol style="list-style-type: decimal;">
        <li>
            <p><strong>Objeto e información general</strong></p>

            <p>
                El presente documento tiene por objeto establecer las Condiciones Generales de Uso de la presente página web, 
                desarrollada por la Fundación Instituto Tecnológico de Galicia (en adelante ITG)  
                inscrita en el Registro de Fundaciones de Interés Gallego con el nº 1991/6 con domicilio social en Rúa Cantón Grande nº 9, 
                Planta 3, Código Postal 15003, en A Coruña (España).      
            </p>
            <p>
                A efectos informativos nuestros datos de contacto son: 
            </p>
            <ul>
                <li>
                    CIF: G-15305923 
                </li>
                <li>
                    Dirección: Rúa Cantón Grande 9, Planta 3 · CP 15190 · A Coruña 
                </li>
                <li>
                    Teléfono: (0034) 981 173 206  
                </li>
                <li>
                    Correo electrónico: itg@itg.es 
                </li>
            </ul>
            <br>
            <p>
                ITG se reserva el derecho a modificar las presentes Condiciones Generales de Uso con el objeto de adecuarlas a la 
                legislación vigente aplicable en cada momento. 
            </p>
            <p>
                Las presentes Condiciones Generales de Uso no excluyen la posibilidad de que determinados Servicios del Portal,
                    por sus características particulares, sean sometidos, además de a las Condiciones Generales de Uso, 
                    a sus propias condiciones particulares de uso (en adelante las Condiciones Particulares). 
            </p>
            <p>
                La utilización por parte del Usuario de cualquiera de los Servicios del Portal supone su adhesión y aceptación expresa a todas las 
                Condiciones Generales de Uso en la versión publicada en el presente portal en el momento en que el usuario acceda al Portal, 
                así como a las Condiciones Particulares que, en su caso, sean de aplicación. 
            </p>
        </li>
        <li>
            <p><strong>Acceso y Aceptación de las Condiciones Generales</strong></p>
            <p>
                Al acceder o usar la Web y apps, lo haces bajo tu única y exclusiva responsabilidad otorgándote la condición de usuario 
                (en adelante, “Usuario” o “Usuarios”) y supone que has leído, 
                entiendes y aceptas expresamente cumplir sin reservas estas Condiciones 
                Generales en la versión publicada en cada momento. En el caso en que utilices 
                Servicios que requieran registro, tanto a título particular como a tÍtulo profesional, 
                pasarás a ser un usuario registrado (en adelante, “Usuario Registrado” o “Usuarios Registrados”), e 
                igualmente supone que aceptas las condiciones particulares que pueden sustituir, completar, y/o modificar estas 
                Condiciones Generales (en adelante, “Condiciones Particulares“) según aplique en cada caso.  
            </p>
            <p>
                En cualquier momento nos reservamos el derecho de ampliar, modificar, 
                sustituir y/o cancelar nuestros Servicios y/o las presentes Condiciones 
                Generales, sin aviso previo y sin que dé lugar a responsabilidad o indemnización 
                alguna por parte de ITG. Haremos lo posible por avisarte de cualquier modificación que puedan sufrir las Condiciones Generales, 
                en particular, si eres Usuario Registrado. Sin embargo, te aconsejamos que revises con frecuencia estas Condiciones Generales 
                para estar al corriente de cualquier cambio que hayamos podido hacer. 
            </p>
            <p>
                Si accedes a la Web y apps o usas los Servicios con posterioridad a que se realice cualquier cambio en las Condiciones Generales, 
                estarás aceptando expresamente las nuevas Condiciones Generales. 
            </p>
            <p>
                Si no estás de acuerdo con estas Condiciones Generales o con cualquier modificación que pueda hacerse de las mismas, 
                debes dejar de usar la Web y apps o los Servicios. Si sigues utilizándolos, estarás aceptando las Condiciones Generales. 
            </p>
            <p>
                A efectos aclaratorios, las presentes Condiciones Generales y las Condiciones Particulares, en su caso, serán de aplicación para todos los usuarios. 
            </p>
        </li>
        <li>
            <p><strong>Menores de edad</strong></p>
            <p>Los Servicios que ofrece esta web no van dirigidos a menores de 18 años. 
                Al acceder o utilizar nuestra Web y apps o Servicios, declaras y garantizas ser mayor de 18 años. 
            </p>
        </li>
        <li>
            <p><strong>Condiciones de uso y responsabilidad por el uso de la Web</strong></p>

            <p>
                El uso que hagas de la Web y App debe respetar las presentes Condiciones Generales, y, en su caso, las Condiciones Particulares, 
                la ley vigente en cada momento, la moral, las buenas costumbres y el orden público.
            </p>
            <p>No puedes hacer un uso ilícito o incorrecto ni que incumpla cualquiera de las disposiciones de estas Condiciones Generales o de las Condiciones Particulares, en su caso. 
                Para facilitarte la navegación y uso de nuestra Web y apps, aquí tienes una lista de lo que puedes y no puedes hacer: 
            </p>
            <span>Puedes: </span>
            <ul>
                <li>
                    Acceder y navegar por la Web y app sin necesidad de registrarte y de forma gratuita 
                </li>
                <li>
                    Contactar con los anunciantes de fincas 
                </li>
                <li>
                    Anunciar para venta o alquiler o consorcio las fincas que sean de tu propiedad o estén bajo tu gestión. 
                </li>
            </ul>
            <span>No puedes introducir, compartir, difundir o publicar: </span> 
            <ul>
                <li>
                    Contenido de carácter racista, xenófobo, obsceno o denigratorio.  
                </li>
                <li>
                    Contenido que incite la realización de actos delictivos, terroristas, violentos o difamatorios por razón de edad, sexo, creencias religiosas o de cualquier tipo. 
                </li>
                <li>
                    Información que constituya publicidad ilícita o desleal.  
                </li>
                <li>
                    Contenido que vulnere el secreto de las comunicaciones y/o la normativa aplicable en materia de protección de datos de carácter personal. 
                </li>
                <li>
                    Contenido falso, inexacto o fraudulento que pueda inducir a error a los destinatarios de dicha información. 
                </li>
            </ul>
            <p>
                Utilizar la Web y Apps para fines ilícitos, ni para reventa, transferencia o disposición para el uso o beneficio de cualquier otra persona o entidad. 
            </p>
            <p>
                Provocar daños en los sistemas informáticos, ni introducir o difundir virus informáticos u otro tipo de sistema 
                nocivo que pueda causar daño en los sistemas informáticos. 
            </p>
            <p>Realizar actos que supongan una lesión de nuestros derechos de Propiedad Intelectual y/o daños reputacionales </p>
            <p>
                Usar la identidad y/o claves de acceso o contraseña de un tercero Usuario Registrado sin su consentimiento. 
            </p>
            <p>
                Infringir las restricciones de los avisos de exclusión de robots incluido en este Sitio Web, así como, puentear o burlar otras medidas empleadas para prevenir o limitar el acceso a este Sitio Web. 
            </p>
            <p>
                Emprender cualquier acción que imponga o pueda imponer, a nuestro criterio, una carga irrazonable o desproporcionadamente grande para nuestra infraestructura. 
            </p>
            <p>
                Establecer un enlace a cualquier contenido de esta Web y app para cualquier que sea su propósito y sin nuestro permiso expreso y por escrito. 
            </p>
            <p>
                Replicar, reflejar o de algún modo incorporar cualquier contenido de esta Web y App en cualquier otro sitio web sin nuestra previa autorización y por escrito. 
            </p>
            <p>
                Si llevas a cabo alguna de estas conductas, responderás por cualquier daño y perjuicio que pudiera surgir como consecuencia del incumplimiento, directo o indirecto, de estas Condiciones Generales o de las Condiciones Particulares, y acuerdas mantener indemne a ITG. En caso de incumplimiento, nos reservamos el derecho de cancelar de forma unilateral y bajo nuestra exclusiva discreción y sin necesidad de preaviso, el acceso, uso, y/o registro a nuestra Web y Apps y Servicios de cualquier Usuario, Usuario Registrado o Anunciante, sin que ello dé lugar en ningún caso a indemnización alguna. 
            </p>
            <p>
                Si observas un uso contrario a estas Condiciones Generales o de las Condiciones Particulares o si tienes conocimiento de que se está produciendo una vulneración de un derecho de ITG o de terceros, te pedimos que nos informes a través de correo electrónico. 
            </p>
        </li>
        <li>
            <p><strong>Publicación de anuncios</strong></p>
            <p>
                Para poder ofrecer tu finca en nuestra Web y Apps mediante la publicación de un anuncio, deberás registrarte. Al hacerlo, garantizas que todos los datos que incluyas en el anuncio son veraces, exactos y actualizados. Desde ITG nos esforzaremos por comprobar la veracidad y exactitud de los datos publicados en los anuncios, pero no podemos garantizar totalmente la veracidad de los datos. Por eso, te comprometes a mantener los datos actualizados en todo momento, notificándonos con la mayor rapidez posible en caso de que algún dato esté desactualizado o fuese inexacto. Al publicar un anuncio reconoces ser el propietario de la finca que anuncias (o estar debidamente autorizado por el propietario de la finca para su publicación) y serás el único responsable de la veracidad de los datos publicados, por lo que responderás en exclusiva ante cualquier responsabilidad o daño que pudiera derivarse al respecto. 
            </p>
            <p>
                ITG no tiene más responsabilidad que la descrita en estas Condiciones Generales y en la normativa aplicable.  
            </p>
            <p>
                Los servicios que ofrece esta web son gratuitos. 
            </p>
        </li>
        <li>
            <p><strong>Normas de publicación de anuncios</strong></p>
            <span>Al utilizar los Servicios de publicación de anuncios, te obligas a: </span>
            <ul>
                <li>
                    No publicar imágenes repetidas o con algún tipo de marco, marca de agua, logotipo o texto. 
                </li>
                <li>
                    No publicar imágenes que no sean relevantes para el anuncio 
                </li>
                <li>
                    No publicar imágenes que no tengan relación con la finca  
                </li>
                <li>
                    No añadir números de teléfono o emails de contacto adicionales fuera del espacio destinado para ese fin en el anuncio. 
                </li>
                <li>
                    No publicar fincas en zonas distintas a la zona especificada. 
                </li>
                <li>
                    No publicar fincas que no estarán disponibles en un corto plazo, no anunciando fincas que se encuentren reservadas o alquiladas o consorciadas. 
                </li>
                <li>
                    A insertar la ubicación exacta 
                </li>
                <li>
                    Reconoces que ITG se reserva el derecho de dar de baja los anuncios que no cumplan con estas normas de publicación o las Condiciones Generales y/o las Condiciones Particulares, en caso de ser de aplicación. 
                </li>
            </ul>
            <span><strong>Medidas antifraude</strong></span>
            <p>
                Con la finalidad de prevenir el uso fraudulento de los Servicios, reconoces y aceptas que ITG podrá poner en cuarentena aquellos anuncios que contengan material sospechoso de ser fraudulento o contrario a estas Condiciones Generales. Los anuncios en cuarentena no serán visibles. 
            </p>
            <p>
                Al utilizar el servicio de publicación reconoces y aceptas que ITG no será responsable por pérdidas y daños directos o indirectos relacionados con el uso fraudulento de los Servicios y, en particular, con la aplicación de los mecanismos y medidas antifraude, lo que incluye, sin limitación alguna: 
            </p>
            <ul>
                <li>
                    La pérdida de ingresos o ganancias.
                </li>
                <li>
                    La pérdida de negocio.
                </li>
                <li>
                    la pérdida de beneficios o contratos; y 
                </li>
                <li>
                    La pérdida de datos. 
                </li>
            </ul>
            <p>
                ITG se reserva el derecho de implementar cualquiera otras medidas antifraude que considere oportunas o necesarias en cada momento. 
            </p>
            <p>
                Por las presentes Condiciones Generales, aceptas que cuando el anuncio haya sido publicado con tu consentimiento al finalizar el proceso de publicación, perderás el derecho de desistimiento, en base a lo dispuesto en el artículo 103 m) del Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el Texto Refundido de la Ley General para la Defensa de Consumidores y Usuarios (“TRLGDCU”). 
            </p>
        </li>
        <li>

            <p><strong>Propiedad Intelectual e Industrial</strong></p>

            <strong>
                7.1 Materiales e información contenidos en la Web y Apps 
            </strong>
            <p>
                Por las presentes Condiciones Generales, reconoces y aceptas que todos los derechos sobre los materiales y elementos que aparecen en la Web y Apps (incluyendo sin carácter limitativo, dibujos, textos, gráficos, mapas, fotografías, imágenes, audio, video, signos distintivos, logos, marcas, nombres comerciales, dominios, software etc.) pertenecen a ITG.. 
            </p>
            <p>
                El hecho de que te permitamos acceder, usar, navegar, utilizar y/o descargar materiales de nuestra Web y Apps en ningún caso implica que renunciemos, o que estemos transmitiendo u concediendo una licencia o cesión de nuestros derechos, ni que adquieras titularidad sobre los mismos. Como Usuario, o como Usuario Registrado tan solo dispones de un derecho de uso estrictamente personal y privado, exclusivamente con la finalidad de disfrutar del Servicio. En consecuencia, no puedes manipular cualquier elemento de identificación. En particular, queda prohibida la utilización de cualquier material o elementos de la Web y Apps para su inclusión, total o parcial, en otros sitios webs o apps ajenos sin contar con nuestra autorización previa y por escrito, y usar cualquier elemento o información de forma que diera la impresión de que los mismos pertenecen o están asociados al Usuario o Usuario Registrado. 
            </p>
            <p>
                En concreto, no está permitido revender, realizar deep-links, utilizar, copiar, monitorizar (por ejemplo, spider, scrape), mostrar, descargar, guardar o reproducir el contenido, la información, el software, los productos o los servicios disponibles en nuestro sitio web para cualquier actividad comercial o competitiva sin autorización previa y por escrito por nuestra parte. 
            </p>
            <strong>
                7.2 Material publicado por el Usuario 
            </strong>
            <p>
                Los materiales e información que publiques en nuestra Web y apps al usar los Servicios deberán respetar los derechos de imagen y de propiedad intelectual e industrial que pudieran existir sobre los mismos. 
            </p>
            <p>
                Al difundir o publicar información, datos no personales, fotografías o cualquier otro material con nosotros, nos concedes una licencia con efectos en todo el mundo, durante el plazo máximo de protección permitido por ley y con la posibilidad de sub licenciar esa información a empresas asociadas y terceros. 
            </p>
        </li>
        <li>    
            <p><strong>Responsabilidad de ITG</strong></p>
            <p>
                Nuestra responsabilidad es la establecida legalmente por la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (en adelante, “LSSI”) que indica que con carácter general, no podemos ser responsables de la información publicada a petición de los Usuarios. 
            </p>
            <p>
                Aunque pongamos nuestros mejores esfuerzos para asegurar que los contenidos publicados sean correctos, no tenemos obligación de ejercer un control previo sobre la veracidad, exactitud, licitud, pertinencia o adecuación de los materiales que se publican en la Web y apps dado que la misma es almacenada a petición de los Usuarios. No obstante, en caso de detectar o sospechar cualquier hecho ilícito o contrario a estas Condiciones Generales o de las Condiciones Particulares, actuaremos con la diligencia debida para retirar la información afectada o hacer imposible su acceso de conformidad con la normativa vigente. 
            </p>
            <p>
                ITG no asumirá ningún tipo de responsabilidad por daños o prejuicios que pudieran derivarse de la relación entre usuarios con motivo de sus contactos o negociaciones.     
            </p>
            <p>
                Los servicios adicionales se regularán conforme a sus condiciones específicas, asumiendo ITG  con relación a los mismos la responsabilidad que le corresponde legalmente. 
            </p>
            <p>
                El acceso y uso de la Web y Apps requiere de un dispositivo o equipo informático y de una conexión a Internet por lo que aceptas que los gastos asociados correrán por tu cuenta. 
            </p>
            <p>
                No somos responsables de la existencia de cualquier carga, gravamen, derecho, conflicto, hipoteca, incidencia, embargo o censo que pudiera afectar las fincas anunciadas en nuestra Web y Apps, y aceptas mantener a ITG indemne de cualquier responsabilidad o daño al respecto. 
            </p>
            No somos responsables de la exactitud, integridad, veracidad, licitud o adecuación de la información, materiales y/o contenidos disponibles en los sitios webs de terceros a los que puedas acceder a través de los enlaces disponibles en nuestra Web y Apps. 
        </li>
        <li>
            <p><strong>Contratación con terceros a través de la Web y Apps</strong></p>

            <p>
                Reconoces y aceptas que cualquier relación contractual o extracontractual que formalices con cualquier anunciante, Usuario, Usuario Registrado o tercero a través de nuestra Web y apps o de nuestros Servicios, será realizado única y exclusivamente entre vosotros. ITG no formará parte, ni asumirá responsabilidad alguna por los daños o perjuicios que pudieran derivarse de esa relación. 
            </p>
            <p>
                Por ello, te recomendamos que actúes con precaución cuando contactes o contrates con cualquier anunciante, Usuario, Usuario Registrado o tercero a través de nuestra Web y Apps. Si tienes cualquier duda o sospechas que se está llevando a cabo alguna actividad ilícita, fraude o alguna conducta contraria a estas Condiciones Generales, te aconsejamos que no formalices contrato y te pongas en contacto con nosotros 
            </p>
        </li>
        <li>
            <p><strong>Enlaces o hiperenlaces a la Web y Apps</strong></p>

            <p>
                Debes solicitar el permiso expreso y por escrito antes de enlazar en profundidad o enmarcar esta Web o cualquiera de sus contenidos.  
            </p>
            <p>
                No debes enlazar nuestra Web y Apps con ningún otro sitio web que contenga temas, materiales o información inapropiados, difamatorios, ilegales, ni materiales o información que violen cualquier derecho de terceros, incluyendo los de propiedad intelectual o industrial. Tampoco permitimos establecer cualquier tipo de frames que permitan la visualización de la Web y Apps a través de una dirección distinta que pueda inducir a error, o engaño a los usuarios sobre la verdadera procedencia de los elementos o servicios que se visualizan, o suponga un acto de competencia desleal (ej. pueda servir para aprovecharse de la reputación y prestigio de ITG , o de cualquier otra forma, resulte contraria a la legislación vigente). 
            </p>
        </li>
        <li>
            <p><strong>Protección de Datos de Carácter Personal</strong></p>

            <p>
                Al acceder a la Web y Apps y/o utilizar los Servicios y Servicios Adicionales, es posible que tratemos tus datos personales. Puedes obtener información detallada sobre la forma y la finalidad para la que trataremos tus datos consultando nuestra Política de Privacidad 
            </p>
        </li>
        <li>
            <p><strong>Duración y término</strong></p>
            <p>
                Tanto el Usuario como ITG pueden poner fin a la relación, sin necesidad de preaviso. 
            </p>
        </li>
        <li>
            <p><strong>Ley aplicable y Jurisdicción</strong></p>
            <p>
                Estas Condiciones Generales están sujetas a las leyes de España. Cualquier conflicto que pudiera derivarse será sometido y resuelto por los juzgados y tribunales. 
            </p>
        </li>
    </ol>

    <div>
        <p align="center">
            <strong>POLÍTICA DE PRIVACIDAD</strong></p>

        <br>    
    </div>

    <br>
    <span>
        Última actualización: 07/09/2020
    </span>    
    <br>
    <ol>
        <br>
        <li>
            <p><strong>RESPONSABLE</strong></p>
            <p>
                Fundación Instituto Tecnológico de Galicia (en adelante ITG)  inscrita en el Registro de Fundaciones de Interés Gallego con el nº 1991/6 con domicilio social en Rúa Cantón Grande nº 9, Planta 3, Código Postal 15003, en A Coruña (España).
            </p>
            <p>
                A efectos informativos nuestros datos de contacto son: 
            </p>
            <ul>
                <li>CIF: G-15305923 </li>
                <li>Dirección: Rúa Cantón Grande 9, Planta 3 · CP 15190 · A Coruña </li>
                <li>Teléfono: (0034) 981 173 206 </li>
                <li>Correo electrónico: itg@itg.es </li>
            </ul>
        </li>
        <br>
        <li>
            <p><strong>FINALIDADES</strong></p>

            <p>
                En cumplimiento de lo dispuesto en el Reglamento Europeo 2016/679 General de Protección de Datos, te informamos de que esta aplicación tratamos los datos que nos facilitas para las siguientes finalidades: 
            </p>
            <ol>
                <li>
                    Realizar una correcta gestión de los servicios a los que te suscribas consistentes en: 
                    <ul>
                        <li>
                            Publicación de anuncios de fincas 
                        </li>
                        <li>
                            Posibilitar el contacto con los anunciantes; en este sentido, se mostrarán los datos personales y la información que incluyas en el formulario de contacto. 
                        </li>
                        <li>
                            Gestión de nuestros servicios, incluyendo recordatorios, avisos técnicos, actualizaciones, alertas de seguridad, mensajes de soporte, entre otros. 
                        </li>
                    </ul>
                </li>
                <li>
                    Prevención de abusos y fraudes en el uso de nuestros servicios (por ejemplo, actividades fraudulentas, ataques de denegación de servicios, envío de spam, entre otros). 
                </li>
                <li>
                    Cesión de datos a organismos y autoridades públicas, siempre y cuando sean requeridos de conformidad con las disposiciones legales y reglamentarias. 
                </li>
            </ol>
        </li>
        <li>
            <p><strong>PLAZO DE CONSERVACIÓN DE LOS DATOS </strong></p>
            <p>
                Tus datos serán conservados mientras dure la relación contractual con nosotros, solicites su supresión, así como el tiempo necesario para cumplir las obligaciones legales. 
            </p>
        </li>
        <li>
            <p><strong>LEGITIMACIÓN </strong></p>
            <p>
                La base legal para el tratamiento de tus datos radica en: 
            </p>
            <ul>
                <li>
                    La ejecución de un contrato con nosotros en relación con las siguientes finalidades: (i) publicación de los anuncios; (ii) contacto con los anunciantes. 
                </li>
                <li>
                    El consentimiento del usuario en relación con las finalidades indicadas. 
                </li>
                <li>
                    El interés legítimo del responsable del tratamiento para la finalidad indicada en el apartado 2 anterior. El interés legítimo consiste en proteger a los usuarios de abusos y fraudes en el uso de nuestros servicios 
                </li>
                <li>
                    El cumplimiento de obligaciones legales aplicables a Fundación Instituto Tecnológico de Galicia para la finalidad indicada en el apartado 2 es necesario para el cumplimiento de obligaciones legales aplicables a ITG. 
                </li>
            </ul>
        </li>
        <li>
            <p><strong>DESTINATARIOS </strong></p>
            <p>Tus datos personales serán comunicados a terceros en los siguientes supuestos: </p>
            <ul>
                <li>
                    En caso de que publiques un anuncio de una finca se mostrará tu información de contacto en la web. 
                </li>
                <li>
                    Tus datos personales también podrán ser cedidos a las autoridades competentes en los casos que exista una obligación legal. 
                </li>
            </ul>
        </li>
        <li>
            <p><strong>DERECHOS </strong></p>
            <p>
                Tienes derecho a obtener confirmación sobre si en ITG estamos tratando datos personales que te conciernan, o no. 
            </p>
            <p>
                Asimismo, tienes derecho a acceder a tus datos personales, así como a solicitar la rectificación de los datos inexactos o, en su caso, solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos. 
            </p>
            <p>
                Adicionalmente, en determinadas circunstancias y por motivos relacionados con tu situación particular, podrás oponerte al tratamiento de tus datos.  
            </p>
            <p>
                Asimismo, puedes ejercer el derecho a la portabilidad de los datos, así como retirar los consentimientos facilitados en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada. 
            </p>
            <p>
                Si deseas hacer uso de cualquiera de tus derechos puedes dirigirte a nosotros mediante el correo electrónicos indicado en el apartado 1.1 
            </p>
            <p>
                Por último, te informamos que puedes dirigirte ante la Agencia Española de Protección de Datos y demás organismos públicos competentes para cualquier reclamación derivada del tratamiento de tus datos personales. 
            </p>
        </li>
    </ol>
</div>
<div class="container" *ngIf="lang === 'pt'">
    <p align="center">
        <strong>CONDIÇÕES DE UTILIZAÇÃO</strong>
    </p>
    <p>
        Última atualização: 09/07/2020
    </p>
    <p>
        <strong>1. </strong>
        <strong>Objetivo e informações gerais</strong>
    </p>
    <p>
        O objetivo deste documento é estabelecer as Condições Gerais de Utilização
        desta página web, desenvolvida pela Fundación Instituto Tecnológico de
        Galícia (doravante ITG), inscrita no Registo de Fundações de Interesse
        Galego com o número 1991/6, com sede em Rúa Cantón Grande, nº 9, Piso 3,
        Código Postal 15003, na Corunha (Espanha).
    </p>
    <p>
        Para fins informativos, os dados de contato do ITG são:
    </p>
    <ul>
        <li>
            CIF: G-15305923
        </li>
        <li>
            Endereço: Rúa Cantón Grande 9, Planta 3 · CP 15190 · Corunha
        </li>
        <li>
            Telefone: (0034) 981 173 206
        </li>
        <li>
            Correio eletrónico: <a href="mailto:itg@itg.es">itg@itg.es</a>
        </li>
    </ul>
    <p>
        O ITG reserva-se no direito de modificar estas Condições Gerais de
        Utilização de forma a adaptá-las à legislação vigente sempre que existam
        atualizações e revisões.
    </p>
    <p>
        As presentes Condições Gerais de Utilização não excluem a possibilidade de
        determinados Serviços do Portal, pelas suas características particulares,
        estarem sujeitos, para além das Condições Gerais de Utilização, às suas
        próprias Condições Particulares de Utilização (doravante Condições
        Particulares).
    </p>
    <p>
        A utilização pelo Utilizador de qualquer dos Serviços do Portal implica a
        sua adesão e aceitação expressa de todas as Condições Gerais de Utilização
        na versão publicada neste Portal no momento em que o utilizador acede ao
        Portal, bem como das Condições Particulares que, quando apropriado, são
        aplicáveis.
    </p>
    <p>
        <strong>2. </strong>
        <strong>Acesso e Aceitação das Condições Gerais</strong>
    </p>
    <p>
        O Utilizador, ao aceder ou utilizar o Website e os Aplicativos, fá-lo sob
        sua única e exclusiva responsabilidade, sendo-lhe concedido o status de
        Utilizador (doravante, "Utilizador" ou "Utilizadores") e pressupõe-se que
        leu, entendeu e concorda expressamente em cumprir com estas Condições
        Gerais sem ressalvas, na versão publicada de acordo com a legislação
        vigente.
    </p>
    <p>
        No caso de utilizar os Serviços que requeiram registo, tanto a título
        pessoal como profissional, tornar-se-á um Utilizador registado (doravante,
        "Utilizador registado" ou "Utilizadores registados"), e também pressupõe
        que aceita as Condições Particulares (doravante, "Condições Particulares")
        conforme aplicável em cada caso.
    </p>
    <p>
        A qualquer momento o ITG reserva-se no direito de expandir, modificar,
        substituir e / ou cancelar estes Serviços e / ou estas Condições Gerais,
        sem aviso prévio e sem dar origem a qualquer responsabilidade ou
        compensação ao Utilizador. O ITG tudo fará para notificar o Utilizador de
        qualquer modificação que as Condições Gerais possam vir a sofrer, em
        particular, se se tratar de um Utilizador registado. No entanto, o ITG
        recomenda que o Utilizador reveja frequentemente estas Condições Gerais
        para estar ciente de quaisquer alterações que possam ter sido efetuadas.
    </p>
    <p>
        Se o Utilizador aceder ou utilizar o Website e os Aplicativos ou utilizar
        os Serviços após qualquer alteração às Condições Gerais, estará a aceitar
        expressamente as novas Condições Gerais.
    </p>
    <p>
        Se o Utilizador não concordar com estas Condições Gerais ou com qualquer
        modificação e/ou atualização que possa ter sido efetuada deverá parar de
        usar o website e os aplicativos ou os Serviços. Se continuar a utilizá-los
        estará a aceitar as Condições Gerais.
    </p>
    <p>
        Para efeitos de esclarecimento, estas Condições Gerais e as Condições
        Particulares, quando for o caso, serão aplicáveis ​​a todos os
        Utilizadores.
    </p>
    <p>
        <strong>3. </strong>
        <strong>Menores</strong>
    </p>
    <p>
        Os Serviços oferecidos por este Website e Aplicativos não são direcionados
        a menores de 18 anos. Ao aceder a este Website, Aplicativos e Serviços, o
        Utilizado declara e garante que é maior de idade (tem mais de 18 anos).
    </p>
    <p>
        <strong>4. </strong>
        <strong>Condições de uso e responsabilidade pelo uso do website</strong>
    </p>
    <p>
        O uso que o Utilizador fizer do Website e dos Aplicativos deve respeitar as
        Condições Gerais e, quando apropriado, as Condições Particulares, a
        legislação em vigor, a moral, os bons princípios e a ordem pública.
    </p>
    <p>
        O Utilizador não pode fazer um uso ilegal ou incorreto ou que viole
        qualquer uma das disposições das Condições Gerais ou das Condições
        Particulares, quando for o caso. Para facilitar a navegação e o uso do
        Website e dos Aplicativos, apresenta-se uma lista do que o Utilizador pode
        e não pode fazer:
    </p>
    <p>
        O Utilizador pode:
    </p>
    <p>
        · Aceder e navegar gratuitamente no Website e nos Aplicativos e sem se
        registar;
    </p>
    <ul>
        <li>
            Entrar em contato com os Anunciantes de propriedades (proprietários);
        </li>
    </ul>
    <p>
        · Introduzir propriedades para venda, arrendamento ou consórcio de que seja
        proprietário ou que se encontrem sob sua gestão.
    </p>
    <p>
        O Utilizador não pode:
    </p>
    <p>
        · Inserir, publicar, compartilhar ou transmitir conteúdo de natureza
        racista, xenófoba, obscena ou degradante;
    </p>
    <p>
        · Inserir, publicar, compartilhar ou transmitir conteúdo que incita atos
        criminosos, terroristas, violentos ou difamatórios com base na idade, sexo,
        crenças religiosas ou de qualquer tipo;
    </p>
    <p>
        · Inserir, publicar, compartilhar ou transmitir informações que originem
        publicidade ilegal ou injusta;
    </p>
    <p>
        · Inserir, publicar, compartilhar ou transmitir conteúdo que viole o sigilo
        das comunicações e / ou os regulamentos aplicáveis ​​relativos à proteção
        de dados pessoais;
    </p>
    <p>
        · Inserir, publicar, compartilhar ou transmitir conteúdo falso, impreciso
        ou fraudulento que possa enganar os destinatários de tais informações;
    </p>
    <p>
        · Utilizar o Website e os Aplicativos apenas para fins ilegais, sem ser
        para revenda, transferência ou para uso ou benefício de qualquer outra
        pessoa ou entidade;
    </p>
    <p>
        · Causar danos aos sistemas informáticos ou introduzir ou espalhar vírus de
        computador ou outros sistemas prejudiciais aos computadores;
    </p>
    <p>
        · Realizar atos que violem os direitos de propriedade intelectual do ITG
        e/ou danos à sua reputação;
    </p>
    <p>
        · Usar ou utilizar a identidade e / ou códigos de acesso ou senha de um
        terceiro Utilizador Registado sem o seu consentimento;
    </p>
    <p>
        · Violar as restrições dos avisos de exclusão de robots incluídos neste
        website, bem como, contornar outras medidas utilizadas para impedir ou
        limitar o acesso a este website;
    </p>
    <p>
        · Desencadear qualquer medida que imponha ou possa impor uma carga
        irracional ou desproporcionalmente grande na infraestrutura do ITG;
    </p>
    <p>
        · Criar um link para qualquer conteúdo deste website e aplicativo para
        qualquer finalidade e sem a permissão do ITG expressa por escrito;
    </p>
    <p>
        · Replicar, refletir ou incorporar de qualquer forma qualquer conteúdo
        deste Website e Aplicativos em qualquer outro website sem a autorização
        prévia, por escrito, do ITG.
    </p>
    <p>
        Se o Utilizador efetuar qualquer uma destas ações será responsável por
        quaisquer danos que possam surgir como consequência da violação, direta ou
        indireta, das Condições Gerais ou das Condições Particulares, e concorda em
        isentar o ITG de qualquer responsabilidade. Em caso de incumprimento, o ITG
        reserva-se no direito de cancelar unilateralmente, e sob seu exclusivo
        critério e sem aviso prévio, o acesso, uso e/ou registo no Website,
        Aplicativos e Serviços de qualquer Utilizador, Utilizador registado ou
        Anunciante, sem dando origem, em qualquer dos casos, a qualquer
        compensação.
    </p>
    <p>
        Se algum Utilizador detetar uma utilização contrária a estas Condições
        Gerais ou às Condições Particulares ou se tiver conhecimento de que está a
        ocorrer uma violação de um direito do ITG ou de terceiros, pedimos-lhe que
        nos informe por email.
    </p>
    <p>
        <strong>5. </strong>
        <strong>Publicação de anúncios</strong>
    </p>
    <p>
        Para poder publicitar a sua propriedade no Website e no Aplicativo através
        de um anúncio, o Utilizador deve registar-se.
    </p>
    <p>
        Ao fazer isso, o Utilizador garante que todas as informações incluídas no
        anúncio são verdadeiras, fidedignas e atualizadas. O ITG fará o possível
        para verificar a veracidade e exatidão dos dados publicados nos anúncios,
        mas não pode garantir a total veracidade dos dados introduzidos. Portanto,
        o Utilizador concorda em manter as informações constantemente atualizadas,
        notificando o ITG, com a brevidade possível, caso algum dado esteja
        desatualizado ou impreciso. Ao publicar um anúncio, o Utilizador reconhece
        que é o proprietário do imóvel que anuncia (ou que está devidamente
        autorizado pelo atual proprietário do imóvel para a sua publicação) e será
        o único responsável pela veracidade dos dados publicados, sendo o
        Utilizador o único responsável por qualquer eventualidade ou dano que possa
        surgir a este respeito.
    </p>
    <p>
        O ITG não tem mais responsabilidades do que as descritas nestas Condições
        Gerais e nos regulamentos aplicáveis.
    </p>
    <p>
        Os Serviços e Aplicativos oferecidos por este website são gratuitos.
    </p>
    <p>
        <strong>6. </strong>
        <strong>Normas de publicação de anúncios</strong>
    </p>
    <p>
        Ao usar os Serviços de publicação de anúncios, o Utilizador concorda em:
    </p>
    <p>
        - Não publicar imagens repetidas ou com qualquer tipo de moldura, marca
        d'água, logotipo ou texto;
    </p>
    <p>
        - Não publicar imagens que não sejam relevantes para o anúncio;
    </p>
    <p>
        - Não publicar imagens que não tenham relação com a propriedade:
    </p>
    <p>
        - Não adicionar outros números de telefone ou e-mails de contato fora do
        espaço designado para essa finalidade no anúncio;
    </p>
    <p>
        - Não publicar propriedades em áreas diferentes da área efetiva/real;
    </p>
    <p>
        - Não publicar propriedades que não fiquem disponíveis a curto prazo, não
        publicitar propriedades reservadas, arrendadas ou geridas em consórcio;
    </p>
    <p>
        - Introduzir a localização exata da propriedade;
    </p>
    <p>
        - Reconhecer que o ITG se reserva no direito de cancelar anúncios que não
        cumpram com estas normas de publicação, Condições Gerais e/ou Condições
        Particulares, conforme aplicável.
    </p>
    <p>
        <strong></strong>
    </p>
    <p>
        <strong>Medidas antifraude</strong>
    </p>
    <p>
        A fim de prevenir o uso fraudulento dos Serviços, o Utilizador reconhece e
        aceita que o ITG pode colocar em quarentena anúncios que contenham material
        suspeito de ser fraudulento ou contrário a estas Condições Gerais. Os
        anúncios em quarentena não ficarão visíveis.
    </p>
    <p>
        Ao utilizar o serviço de publicação, o Utilizador reconhece e aceita que o
        ITG não será responsável por perdas e danos, diretos ou indiretos,
        relacionados com o uso fraudulento dos Serviços e, em particular, com a
        aplicação de mecanismos e medidas antifraude, que incluem, sem qualquer
        limitação:
    </p>
    <p>
        - A perda de receita ou lucro:
    </p>
    <p>
        - A perda de negócios;
    </p>
    <p>
        - A perda de lucros cessantes ou contratos; e
    </p>
    <p>
        - A perda de dados.
    </p>
    <p>
        O ITG reserva-se no direito de implementar quaisquer outras medidas
        antifraude que julgar apropriadas ou necessárias a qualquer momento.
    </p>
    <p>
        Por estas Condições Gerais, o Utilizador aceita que, quando o anúncio for
        publicado com o seu consentimento no final do processo de publicação,
        perderá o direito de rescisão, com base no disposto no artigo 103 m) do
        Real Decreto Legislativo 1/2007, de 16 de novembro, que aprova o Texto
        Consolidado da Lei Geral de Defesa do Consumidor e do Utilizador
        (“TRLGDCU”).
    </p>
    <p>
        <strong>7. </strong>
        <strong>Propriedade Intelectual e Industrial</strong>
    </p>
    <p>
        <strong>
            7.1. Materiais e informações contidos no Website e Aplicativos
        </strong>
    </p>
    <p>
        Por estas Condições Gerais, o Utilizador reconhece e aceita que todos os
        direitos sobre os materiais e elementos que aparecem no Website e
        Aplicativos (incluindo, sem limitação, desenhos, textos, gráficos, mapas,
        fotografias, imagens, áudio, vídeo, sinais distintivos, logotipos, marcas,
        nomes comerciais, domínios, software, etc.) pertencem ao ITG.
    </p>
    <p>
        O facto de o ITG permitir que o Utilizador aceda, use, navegue e faça
        download de materiais do Website e Aplicativos em nenhum caso implica que
        renuncie, ou que esteja a transmitir ou conceder uma licença ou
        transferência dos seus direitos, nem que o Utilizador adquira titularidade
        sobre eles próprios. Como Utilizador, ou como Utilizador Registado, tem
        apenas o direito de uso estritamente pessoal e privado, exclusivamente para
        o propósito de usufruir do serviço. Consequentemente, o Utilizador não pode
        alterar qualquer elemento de identificação.
    </p>
    <p>
        É proibido o uso de qualquer material ou elementos do Website e Aplicativos
        para inclusão, no todo ou em parte, em outros websites ou aplicativos de
        terceiros, usando qualquer elemento ou informação de maneira que dê a
        impressão de que pertencem ou estão associados ao Utilizador ou Utilizador
        Registado, sem a autorização prévia por escrito do ITG.
    </p>
    <p>
        Especificamente, não é permitido revender, criar deep-links (links
        diretos), utilizar, copiar, monitorizar (por exemplo, spider, scrape),
        exibir/mostrar, descarregar, guardar ou reproduzir o conteúdo, informações,
        software, produtos ou serviços disponíveis no Website para qualquer
        atividade comercial, ou análoga à do projeto, sem a autorização prévia por
        escrito do ITG.
    </p>
    <p>
        <strong>7.2. Material publicado pelo Utilizador</strong>
    </p>
    <p>
        Ao usar os Serviços, os materiais e informações que o Utilizador publique
        no Website e Aplicativos devem respeitar a imagem e os direitos de
        propriedade intelectual e industrial que possam existir sobre os mesmos.
    </p>
    <p>
        Ao divulgar ou publicar informação, dados não pessoais, fotografias ou
        qualquer outro material, o Utilizador concede ao ITG uma licença com
        efeitos a nível mundial, pelo período máximo de proteção permitido por lei
        e com a possibilidade de sub-licenciar essa informação a empresas
        associadas e terceiros.
    </p>
    <p>
        <strong>8. </strong>
        <strong>Responsabilidade do ITG</strong>
    </p>
    <p>
        A responsabilidade do ITG está legalmente estabelecida pela Lei 34/2002, de
        11 de julho, de Serviços da Sociedade da Informação e Comércio Eletrónico
        (doravante, "LSSI") que estabelece que, em geral, o ITG não pode ser
        responsável ​​pelas informações publicadas a pedido dos Utilizadores.
    </p>
    <p>
        Embora o ITG coloque os seus melhores esforços para garantir que os
        conteúdos publicados sejam corretos, não tem a obrigação de exercer
        controlo prévio sobre a veracidade, exatidão, legalidade, relevância ou
        adequação das informações que são publicadas no Website e Aplicativos dado
        que estas são guardadas a pedido dos Utilizadores. No entanto, em caso de
        deteção ou suspeita de qualquer ato ilícito ou contrário às presentes
        Condições Gerais ou Condições Particulares, o ITG atuará com a devida
        diligência para remover as informações afetadas ou impossibilitar o seu
        acesso de acordo com a regulamentação em vigor.
    </p>
    <p>
        O ITG não assumirá qualquer tipo de responsabilidade por danos ou prejuízos
        que possam derivar da relação entre os Utilizadores face aos seus contatos
        ou negociações.
    </p>
    <p>
        Os serviços adicionais serão regulados de acordo com as suas condições
        específicas, assumindo o ITG a responsabilidade que lhe corresponda
        legalmente.
    </p>
    <p>
        O acesso e uso/utilização do Website e Aplicativos requer um dispositivo ou
        equipamento informático e uma conexão à Internet, pelo que o Utilizador
        aceita que as despesas associadas sejam suportadas por este.
    </p>
    <p>
        O ITG não é responsável ​​pela existência de qualquer encargo, taxa,
        direito, conflito, hipoteca, incidência, embargo ou censo que possa afetar
        as propriedades anunciadas no seu Website e Aplicativos, concordando o
        Utilizador em isentar o ITG de qualquer responsabilidade ou dano a este
        respeito.
    </p>
    <p>
        O ITG não é responsável ​​pela exatidão, integridade, veracidade,
        legalidade ou adequação das informações, materiais e / ou conteúdos
        disponíveis em websites de terceiros a que o Utilizador possa aceder
        através de links disponíveis no Website e Aplicativos.
    </p>
    <p>
        <strong>9. </strong>
        <strong>Contratação com terceiros através do Website e Aplicativos</strong>
    </p>
    <p>
        O Utilizador reconhece e aceita que qualquer relação contratual ou
        extracontratual que formalize com qualquer Anunciante, Utilizador,
        Utilizador Registado ou terceiro através do Website e Aplicativos ou dos
        seus Serviços, será realizada única e exclusivamente entre ambos. O ITG não
        fará parte, nem assumirá qualquer responsabilidade por quaisquer danos que
        possam surgir dessa relação.
    </p>
    <p>
        Portanto, o ITG recomenda que o Utilizador atue com cautela ao contatar ou
        contratar qualquer Anunciante, Utilizador, Utilizador Registado ou terceiro
        através do Website e Aplicativos. Caso o Utilizador tenha alguma dúvida ou
        suspeite da realização de qualquer atividade ilegal, fraude ou conduta
        contrária a estas Condições Gerais, o ITG aconselha a não formalizar
        qualquer contrato e a contactar os nossos Serviços.
    </p>
    <p>
        <strong>10. </strong>
        <strong>Links ou hiperlinks através do Website e Aplicativos</strong>
    </p>
    <p>
        O Utilizador deve solicitar permissão expressa por escrito ao ITG antes de
        criar links ou vincular em profundidade ou enquadrar este Website ou
        qualquer um de seus conteúdos sem a autorização prévia por escrito do ITG.
    </p>
    <p>
        O Utilizador não deve vincular o Website e Aplicativos a qualquer outro
        website que contenha tópicos, materiais ou informações inapropriadas,
        difamatórias ou ilegais, nem materiais ou informações que violem direitos
        de terceiros, incluindo os de propriedade intelectual ou industrial.
        Tampouco o ITG permite o estabelecimento de qualquer tipo de frames que
        possibilitem a visualização do Website e Aplicativos por meio de um
        endereço diferente que possa enganar ou induzir em erro os Utilizadores
        sobre a verdadeira origem dos elementos ou serviços que são exibidos, ou
        que suponha um ato injusto de concorrência (por exemplo, poder servir para
        tirar proveito da reputação e prestígio do ITG, ou de qualquer outra forma
        que resulte contrariamente à legislação em vigor).
    </p>
    <p>
        <strong>11. </strong>
        <strong>Proteção de dados pessoais</strong>
    </p>
    <p>
        Ao aceder ao Website e Aplicativos e / ou utilizar os Serviços e Serviços
        Adicionais, é possível que o ITG processe os dados pessoais do Utilizador.
        O Utilizador pode obter informações detalhadas sobre a forma e a finalidade
        como o ITG tratará seus dados, consultando a sua Política de Privacidade.
    </p>
    <p>
        <strong>12. </strong>
        <strong>Duração e prazo</strong>
    </p>
    <p>
        Tanto o Utilizador como o ITG podem por fim à sua relação, sem necessidade
        de aviso prévio.
    </p>
    <p>
        <strong></strong>
    </p>
    <p>
        <strong></strong>
    </p>
    <p>
        <strong>13. </strong>
        <strong>Lei Aplicável e Jurisdição</strong>
    </p>
    <p>
        Estas Condições Gerais estão sujeitas às leis da Espanha. Qualquer conflito
        que possa surgir será submetido e resolvido pelos julgados e tribunais
        competentes.
    </p>
    <strong>
        <br clear="all"/>
    </strong>
    <p>
        <strong></strong>
    </p>
    <p align="center">
        <strong>POLÍTICA DE PRIVACIDADE</strong>
    </p>
    <p>
        Última atualização: 09/07/2020
    </p>
    <p>
        <strong>1. </strong>
        <strong>RESPONSÁVEL</strong>
    </p>
    <p>
        A Fundação Instituto Tecnológico de Galícia (doravante ITG) inscrita no
        Registo de Fundações de Interesse Galego com o número 1991/6, com sede na
        Rúa Cantón Grande nº 9, Andar 3, Código Postal 15003, na Corunha (Espanha).
    </p>
    <p>
        Para fins informativos, os dados de contato do ITG são:
    </p>
    <ul>
        <li>
            CIF: G-15305923
        </li>
        <li>
            Endereço: Rúa Cantón Grande 9, Planta 3 · CP 15190 · Corunha
        </li>
        <li>
            Telefone: (0034) 981 173 206
        </li>
        <li>
            Correio eletrónico: <a href="mailto:itg@itg.es">itg@itg.es</a>
        </li>
    </ul>
    <p>
        <strong></strong>
    </p>
    <p>
        <strong></strong>
    </p>
    <p>
        <strong>2. </strong>
        <strong>OBJETIVOS</strong>
    </p>
    <p>
        Em conformidade com as disposições do Regulamento Europeu 2016/679 da
        Proteção Geral de Dados, o ITG informa que este aplicativo trata os dados
        que o Utilizador fornece para os seguintes fins:
    </p>
    <p>
        1. Realizar uma gestão correta dos serviços que o Utilizador subscreve,
        consistindo em:
    </p>
    <ul>
        <li>
            Publicação de anúncios de propriedades;
        </li>
    </ul>
    <p>
        · Possibilitar o contato com os Anunciantes: nesse sentido, serão exibidos
        os dados e informações pessoais que o Utilizador incluiu no formulário de
        contato;
    </p>
    <p>
        · Gestão dos serviços, incluindo lembretes, avisos técnicos, atualizações,
        alertas de segurança, mensagens de suporte, entre outros.
    </p>
    <p>
        2. Prevenção de abusos e fraudes na utilização dos nossos serviços (por
        exemplo, atividades fraudulentas, ataques de negação de serviços, envio de
        spam, entre outros).
    </p>
    <p>
        3. Cedência de dados a organismos e autoridades públicas, desde que
        exigidos de acordo com as disposições legais e regulamentares.
    </p>
    <p>
        <strong>3. </strong>
        <strong>PRAZO DE CONSERVAÇÃO DE DADOS</strong>
    </p>
    <p>
        Os dados do Utilizador serão guardados durante a duração da relação
        contratual com o ITG, solicite a sua eliminação, bem como o tempo
        necessário para cumprir as obrigações legais.
    </p>
    <p>
        <strong>4. </strong>
        <strong>LEGITIMAÇÃO</strong>
    </p>
    <p>
        A base legal para o tratamento dos dados do Utilizador baseia-se:
    </p>
    <p>
        · Na realização de um contrato com o ITG em relação aos seguintes fins: (i)
        publicação de anúncios; (ii) contato com Anunciantes;
    </p>
    <ul>
        <li>
            No consentimento do Utilizador em relação aos fins indicados;
        </li>
    </ul>
    <p>
        · No legítimo interesse do Encarregado de Proteção de Dados para os fins
        indicados nos Objetivos (secção 2). O legítimo interesse consiste em
        proteger os Utilizadores de abusos e fraudes na utilização dos serviços do
        ITG;
    </p>
    <p>
        · No cumprimento das obrigações legais aplicáveis ​​à Fundação Instituto
        Tecnológico de Galícia para os fins indicados nos Objetivos (secção 2). Tal
        é necessário para o cumprimento das obrigações legais aplicáveis ​​ao ITG.
    </p>
    <p>
        <strong>5. </strong>
        <strong>DESTINATÁRIOS</strong>
    </p>
    <p>
        Os dados pessoais do Utilizador serão comunicados a terceiros nos seguintes
        casos:
    </p>
    <p>
        · Se o Utilizador publicar um anúncio de uma propriedade as suas
        informações de contato serão exibidas na web;
    </p>
    <p>
        · Os dados pessoais do Utilizador também podem ser transferidos para as
        autoridades competentes nos casos em que haja uma obrigação legal.
    </p>
    <p>
        <strong>6. </strong>
        <strong>DIREITOS</strong>
    </p>
    <p>
        O Utilizador tem o direito de obter confirmação se o ITG está, ou não, a
        tratar os seus dados pessoais.
    </p>
    <p>
        Da mesma forma, o Utilizador tem o direito de aceder aos seus dados
        pessoais, bem como solicitar a retificação de dados incorretos ou, se for o
        caso, solicitar sua exclusão quando, entre outros motivos, os dados não
        forem mais necessários para os fins para os quais foram recolhidos.
    </p>
    <p>
        Além disso, em certas circunstâncias e por razões relacionadas à sua
        situação particular, o Utilizador pode opor-se ao tratamento dos seus dados
        pessoais.
    </p>
    <p>
        O Utilizador pode exercer o direito à portabilidade dos dados, bem como
        retirar as autorizações concedidas a qualquer momento, sem afetar a
        legalidade do tratamento com base na autorização anterior à sua retirada.
    </p>
    <p>
        Se o Utilizador desejar fazer uso de algum dos seus direitos, pode
        contactar o ITG através do endereço de correio eletrónico indicado na
        secção 1.
    </p>
    <p>
        Por último, o ITG informa o Utilizador de que pode contactar a Agência
        Espanhola de Proteção de Dados e outros organismos públicos competentes
        para qualquer reclamação decorrente do tratamento dos seus dados pessoais.
    </p>
</div>